import React from 'react';
import HelpPanel from '@cloudscape-design/components/help-panel';
import { ExternalLinkGroup } from './common';

export function DashboardHelp() {
  return (
    <HelpPanel
      header={<h2>Dashboard</h2>}
      footer={
        <ExternalLinkGroup
          items={[
            { href: '#', text: 'Customer Feedback System Documentation' },
            { href: '#', text: 'Understanding Notification Types' },
            { href: '#', text: 'Admin Actions Guide' }
          ]}
        />
      }
    >
      <p>
        The Dashboard provides an overview of your customer feedback notification system's activity and performance.
      </p>
      
      <h3>Key Metrics</h3>
      <p>
        The status cards at the top display important metrics including:
      </p>
      <ul>
        <li><strong>Emails Sent</strong>: Total number of notification emails sent to account managers</li>
        <li><strong>Open Rate</strong>: Percentage of emails that have been opened</li>
        <li><strong>Slack Notifications</strong>: Number of escalations sent to Slack</li>
        <li><strong>Pending Events</strong>: Events waiting to be processed</li>
      </ul>
      
      <h3>Charts and Visualizations</h3>
      <p>
        The Notifications by Type chart shows the distribution of different notification types over the past 30 days.
      </p>
      
      <h3>Admin Actions</h3>
      <p>
        Administrators have access to additional actions:
      </p>
      <ul>
        <li><strong>Run Event Processor</strong>: Manually trigger the event processing pipeline to query for new events</li>
        <li><strong>Run Event Escalation</strong>: Manually trigger the escalation process for unread notifications</li>
      </ul>
      
      <h3>Recent Activity</h3>
      <p>
        The Recent Activity section shows the latest events, notifications, and tracking information in the system.
      </p>
    </HelpPanel>
  );
}
